<template>
    <div class="cell-tooltip" :style="{ backgroundColor: color }">
        <p>
          <span v-if="showCurrency">€</span>
          <span>{{ value }}</span>
          <span v-if="showPercentage">%</span>
        </p>
    </div>
</template>

 <script>
import moment from 'moment';

export default {
  name: 'ToolTipRenderer',
  data() {
    return {
      data: null,
    };
  },
  computed: {
      color() {
        return this.params.color || 'white';
      },
      value() {
        if (this.isDate) {
          return moment(this.params.value).format('DD/MM/YYYY');
        }

        return this.params.value;
      },
      isDate() {
         return !! this.params.isDate;
      },
      showPercentage() {
        return !! this.params.showPercentage
      },
      showCurrency() {
        return !! this.params.showCurrency
      },
  },
  beforeMount() {
    this.data = this.params.api.getDisplayedRowAtIndex(this.params.rowIndex).data;
  }
}
</script>

<style lang="scss" scoped>
.cell-tooltip {
  border: 1px solid #e7e6e6;
  padding: 15px;
  width: auto;
}
</style>